import { FunctionComponent } from "react";
import { Redirect, Route } from "react-router-dom";
import { IonRouterOutlet } from "@ionic/react";
import { RouteNames } from "../constantes/routes.const";
import { RequireAuthGuard } from "../guards/require-auth.guard";
import { LoginPage } from "../../../pages/login.page";
import { SitesPage } from "../../../pages/sites.page";
import { SitePage } from "../../../pages/site/site.page";
import { SiteAnnotationsPage } from "../../../pages/site/site-annotations.page";
import { OutdoorAreasPage } from "../../../pages/site/outdoor-areas/outdoor-areas.page";
import { BuildingPage } from "../../../pages/site/building/building.page";
import { FloorPage } from "../../../pages/site/building/floor/floor.page";
import { NotFoundRedirect } from "./not-found-redirect.component";
import { ErrorPage } from './errorpage/error.page';
import { AnnotationsList } from '../../annotation/components/annotations-list.component';
import { AnnotationFilters } from '../../annotation/components/annotation-filters.component';
import { OrganizationUrlHandler } from "./organization-url-handler.component";

export const PageRouting: FunctionComponent = () => (
  <OrganizationUrlHandler>
    <IonRouterOutlet>
      <Route exact path={RouteNames.login}>
        <LoginPage />
      </Route>
      {/* Routes avec code organisation */}
      <RequireAuthGuard exact path={RouteNames.home}>
        <SitesPage />
      </RequireAuthGuard>
      <RequireAuthGuard exact path={RouteNames.site}>
        <SitePage />
      </RequireAuthGuard>
      <RequireAuthGuard exact path={RouteNames.siteAnnotations}>
        <SiteAnnotationsPage />
      </RequireAuthGuard>
      <RequireAuthGuard exact path={RouteNames.outdoorAreas}>
        <OutdoorAreasPage />
      </RequireAuthGuard>
      <RequireAuthGuard exact path={RouteNames.building}>
        <BuildingPage />
      </RequireAuthGuard>
      <RequireAuthGuard exact path={RouteNames.floor}>
        <FloorPage />
      </RequireAuthGuard>
      <RequireAuthGuard exact path={RouteNames.annotations}>
        <AnnotationsList />
      </RequireAuthGuard>
      <RequireAuthGuard exact path={RouteNames.annotationFilters}>
        <AnnotationFilters />
      </RequireAuthGuard>
      {/* Routes sans code organisation (rétrocompatibilité) */}
      <RequireAuthGuard exact path={RouteNames.homeWithoutOrg}>
        <SitesPage />
      </RequireAuthGuard>
      <RequireAuthGuard exact path={RouteNames.siteWithoutOrg}>
        <SitePage />
      </RequireAuthGuard>
      <RequireAuthGuard exact path={RouteNames.siteAnnotationsWithoutOrg}>
        <SiteAnnotationsPage />
      </RequireAuthGuard>
      <RequireAuthGuard exact path={RouteNames.outdoorAreasWithoutOrg}>
        <OutdoorAreasPage />
      </RequireAuthGuard>
      <RequireAuthGuard exact path={RouteNames.buildingWithoutOrg}>
        <BuildingPage />
      </RequireAuthGuard>
      <RequireAuthGuard exact path={RouteNames.floorWithoutOrg}>
        <FloorPage />
      </RequireAuthGuard>
      <RequireAuthGuard exact path={RouteNames.annotationsWithoutOrg}>
        <AnnotationsList />
      </RequireAuthGuard>
      <RequireAuthGuard exact path={RouteNames.annotationFiltersWithoutOrg}>
        <AnnotationFilters />
      </RequireAuthGuard>
      <Route exact path={RouteNames.notFound}>
        <NotFoundRedirect />
      </Route>
      <RequireAuthGuard exact path={RouteNames.errorPage404}>
        <ErrorPage errorCode={'404'}/>
      </RequireAuthGuard>
      <RequireAuthGuard exact path={RouteNames.errorPage500}>
        <ErrorPage errorCode={'500'}/>
      </RequireAuthGuard>
      <Redirect to={RouteNames.notFound} />
    </IonRouterOutlet>
  </OrganizationUrlHandler>
);
